const content = [
  // 第一章 第七节 Self-Regulated Learning
  // 小标题
  {
    key: 'section7',
    type: "title",
    category: 7, // *必填* 分类 1：章头 2：节头 3：小标题 ...
    // shortText: '1.1', // 小标题文本，有值的时候展示 例如：第一章、第一节等
    text: "Self-Regulated Learning", // *必填* 标题文本内容
    titleImage: require("@/assets/images/books/book2/title-back.png"),
    textStyle: {
        // fontFamily: 'Microsoft Yahei', // 字体，本地配置的字体
        fontSize: 38, // 文字大小  默认：26
        // lineHeight: 40, // 行高  默认：46
        textIndent: 55, // 首行缩进  默认：0 可以使用距离px也可以使用字节数2em
        // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：加粗
        // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
        // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
        // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
        color: '#5CA683', // 文本颜色  默认：#00a8ac
        // backgroundColor: '#FFF', // 背景颜色  默认：无
        // backgroundImage: require("@/assets/images/bookContent/chapter_title_bg.png") // 背景图片  默认：无
        marginTop: 24,
    },
  },
  {
    key: 'section7.0',
    type: "title",
    category: 4, // *必填* 分类 1：章头 2：节头 3：小标题 ...
    // shortText: '1.1', // 小标题文本，有值的时候展示 例如：第一章、第一节等
    text: "Delve into the Culture of Traditional Chinese Festivals", // *必填* 标题文本内容
    textStyle: {
        fontFamily: 'Arial', // 字体，本地配置的字体
        fontSize: 32, // 文字大小  默认：26
        lineHeight: 36, // 行高  默认：46
        textIndent: 0, // 首行缩进  默认：0 可以使用距离px也可以使用字节数2em
        // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：加粗
        // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
        // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
        textAlign: 'center', // 文字对齐方式 left：左 right：右 center：居中  默认：left
        color: '#333333', // 文本颜色  默认：#00a8ac
        // backgroundColor: '#FFF', // 背景颜色  默认：无
        // backgroundImage: require("@/assets/images/bookContent/chapter_title_bg.png") // 背景图片  默认：无
        marginTop: 30,
        paddingLeft: 50,
        paddingRight: 50,
    },
  },
  // 模板样式 单个带边框
  {
    key: 'section7.1',
    type: 'template',
    category: 1, // *必填* 分类 1：单个带边框 2：两级tabs 3：可收起模块
    templateStyle: {
      // fontFamily: 'Microsoft Yahei', // 字体，本地配置的字体
      // fontSize: 38, // 文字大小  默认：26
      // lineHeight: 40, // 行高  默认：46
      // textIndent: 55, // 首行缩进  默认：0 可以使用距离px也可以使用字节数2em
      // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：加粗
      // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
      // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
      // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
      // color: '#5CA683', // 文本颜色  默认：#00a8ac
      // backgroundColor: '#FFF', // 背景颜色  默认：无
      marginTop: 30,
      // marginBottom: 30,
      padding: 25,
      backgroundColor: '#D2E3D9',
      // paddingTop: 0,
      // paddingBottom: 0,
      borderRadius: 0,
      border: 'none',
      borderTop: 'none',
      borderBottom: 'none',
      borderLeft: '6rem solid #5CA683',
      borderRight: 'none'
    },
    content: [
      { //右侧文本内容，目前只有一段文字
        key: 'section7.1.1', // *必填* 唯一标识
        type: 'text', // *必填* 类型：正文
        isInTable: true,
        content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
          {
            key: 'section7.1.1.1', // *必填* 唯一标识
            category: 'text', // *必填* 内容类型 text：文本
            text: 'Your class will begin a cultural exploration journey next week, focusing on the theme “Inherit and Spread the Culture of Traditional Chinese Festivals”. This week-long event aims to encourage students to delve into the cultural diversity of Chinese festivals and highlights the historical, cultural, and social significance of the time-honored traditions. Work in groups to write an article under this theme and upload it to the Weixin subscription account of your class.', // *必填* 文本内容
            textStyle: {},
          }
        ],
        textStyle: {
          fontFamily: 'Calibri', // 字体，本地配置的字体
          fontSize: 28, // 文字大小  默认：20
          lineHeight: 42, // 行高  默认：36
          textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
          // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
          // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
          fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
          // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
          color: '#333', // 文本颜色  默认：#00a8ac
          // backgroundColor: '#FFF', // 背景颜色  默认：无
        },
      },
    ],
  },
  {
    key: 'section7.2',
    type: 'paragraph',
    category: 'withBefore',
    leftMark: { // 左侧标记
      type: 'block', // block: 左侧占满 inline：仅第一行有缩进
      width: 97,
      height: 40,
      text: 'Step 1',
      textStyle: {
        fontFamily: 'Calibri', // 字体，本地配置的字体
        fontSize: 24, // 文字大小  默认：20
        lineHeight: 40, // 行高  默认：36
        // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
        fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
        // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
        // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
        textAlign: 'center', // 文字对齐方式 left：左 right：右 center：居中  默认：left
        color: '#fff', // 文本颜色  默认：#00a8ac
        // backgroundColor: '#5CA683', // 背景颜色  默认：无
        backgroundImage: require("@/assets/images/books/book2/title-mark-icon-1.png"),
        paddingLeft: 0,
        paddingRight: 15,
        marginLeft: 0,
        marginRight: 14,
        marginTop: 0,
        marginBottom: 0,
        top: 0,
        left: 0,
      }
    },
    content: { //右侧文本内容，目前只有一段文字
      key: 'section7.2.1', // *必填* 唯一标识
      type: 'text', // *必填* 类型：正文
      isInTable: true,
      content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
        {
          key: 'section7.2.1.1', // *必填* 唯一标识
          category: 'text', // *必填* 内容类型 text：文本
          text: 'Choose a traditional Chinese festival.', // *必填* 文本内容
          textStyle: {
            fontFamily: 'Arial', // 字体，本地配置的字体
            fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：加粗
          },
        }
      ],
      textStyle: {
        // fontFamily: 'xxx', // 字体，本地配置的字体
        // fontSize: 20, // 文字大小  默认：20
        // lineHeight: 40, // 行高  默认：36
        // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
        // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
        // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
        // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
        // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
        color: '#333', // 文本颜色  默认：#00a8ac
        // backgroundColor: '#FFF', // 背景颜色  默认：无
      },
    },
    // 段落内外间距
    paragraphStyle: {
        marginTop: 34,
        marginBottom: 0,
        padding: 0,
        paddingLeft: 20,
        paddingRight: 20,
    }
  },
  {
    key: 'section7.3',
    type: 'table',
    styleType: 3, // 表格样式 3：英语项目可输入左右表格
    content: [
      {
        key: 'section7.3.1',
        title: 'The Festival You Choose',
        type: 'input'
      },
      {
        key: 'section7.3.2',
        title: 'Your Reason(s)',
        type: 'input',
        height: 260
      }
    ]
  },
  {
    key: 'section7.4',
    type: 'paragraph',
    category: 'withBefore',
    leftMark: { // 左侧标记
      type: 'block', // block: 左侧占满 inline：仅第一行有缩进
      width: 97,
      height: 40,
      text: 'Step 2',
      textStyle: {
        fontFamily: 'Calibri', // 字体，本地配置的字体
        fontSize: 24, // 文字大小  默认：20
        lineHeight: 40, // 行高  默认：36
        // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
        fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
        // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
        // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
        textAlign: 'center', // 文字对齐方式 left：左 right：右 center：居中  默认：left
        color: '#fff', // 文本颜色  默认：#00a8ac
        // backgroundColor: '#5CA683', // 背景颜色  默认：无
        backgroundImage: require("@/assets/images/books/book2/title-mark-icon-1.png"),
        paddingLeft: 0,
        paddingRight: 15,
        marginLeft: 0,
        marginRight: 14,
        marginTop: 0,
        marginBottom: 0,
        top: 0,
        left: 0,
      }
    },
    content: { //右侧文本内容，目前只有一段文字
      key: 'section7.4.1', // *必填* 唯一标识
      type: 'text', // *必填* 类型：正文
      isInTable: true,
      content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
        {
          key: 'section7.4.1.1', // *必填* 唯一标识
          category: 'text', // *必填* 内容类型 text：文本
          text: 'Delve into the cultural aspects of the festival.', // *必填* 文本内容
          textStyle: {
            fontFamily: 'Arial', // 字体，本地配置的字体
            fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：加粗
          },
        }
      ],
      textStyle: {
        // fontFamily: 'xxx', // 字体，本地配置的字体
        // fontSize: 20, // 文字大小  默认：20
        // lineHeight: 40, // 行高  默认：36
        // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
        // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
        // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
        // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
        // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
        color: '#333', // 文本颜色  默认：#00a8ac
        // backgroundColor: '#FFF', // 背景颜色  默认：无
      },
    },
    // 段落内外间距
    paragraphStyle: {
        marginTop: 34,
        marginBottom: 0,
        padding: 0,
        paddingLeft: 20,
        paddingRight: 20,
    }
  },
  {
    key: 'section7.5',
    type: 'table',
    styleType: 3, // 表格样式 3：英语项目可输入左右表格
    content: [
      {
        key: 'section7.5.1',
        title: 'Background and  Origin',
        type: 'input'
      },
      {
        key: 'section7.5.2',
        title: 'Customs and  Traditions',
        type: 'input'
      },
      {
        key: 'section7.5.3',
        title: 'Significance and  Symbolism',
        type: 'input'
      },
      {
        key: 'section7.5.4',
        title: 'Food and Cuisine',
        type: 'input'
      },
      {
        key: 'section7.5.5',
        title: 'Impact on Society',
        type: 'input'
      },
      {
        key: 'section7.5.6',
        title: ' ...',
        type: 'input'
      }
    ]
  },
  {
    key: 'section7.6',
    type: 'paragraph',
    category: 'withBefore',
    leftMark: { // 左侧标记
      type: 'block', // block: 左侧占满 inline：仅第一行有缩进
      width: 97,
      height: 40,
      text: 'Step 3',
      textStyle: {
        fontFamily: 'Calibri', // 字体，本地配置的字体
        fontSize: 24, // 文字大小  默认：20
        lineHeight: 40, // 行高  默认：36
        // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
        fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
        // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
        // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
        textAlign: 'center', // 文字对齐方式 left：左 right：右 center：居中  默认：left
        color: '#fff', // 文本颜色  默认：#00a8ac
        // backgroundColor: '#5CA683', // 背景颜色  默认：无
        backgroundImage: require("@/assets/images/books/book2/title-mark-icon-1.png"),
        paddingLeft: 0,
        paddingRight: 15,
        marginLeft: 0,
        marginRight: 14,
        marginTop: 0,
        marginBottom: 0,
        top: 0,
        left: 0,
      }
    },
    content: { //右侧文本内容，目前只有一段文字
      key: 'section7.6.1', // *必填* 唯一标识
      type: 'text', // *必填* 类型：正文
      isInTable: true,
      content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
        {
          key: 'section7.6.1.1', // *必填* 唯一标识
          category: 'text', // *必填* 内容类型 text：文本
          text: 'Outline the article. Create an outline to organize your thoughts and ideas. This will help you plan the structure of your article, including the introduction, main body, and conclusion.', // *必填* 文本内容
          textStyle: {
            fontFamily: 'Arial', // 字体，本地配置的字体
            fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：加粗
          },
        }
      ],
      textStyle: {
        // fontFamily: 'xxx', // 字体，本地配置的字体
        // fontSize: 20, // 文字大小  默认：20
        // lineHeight: 40, // 行高  默认：36
        // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
        // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
        // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
        // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
        // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
        color: '#333', // 文本颜色  默认：#00a8ac
        // backgroundColor: '#FFF', // 背景颜色  默认：无
      },
    },
    // 段落内外间距
    paragraphStyle: {
        marginTop: 34,
        marginBottom: 0,
        padding: 0,
        paddingLeft: 20,
        paddingRight: 20,
    }
  },
  {
    key: 'section7.7',
    type: 'table',
    styleType: 3, // 表格样式 3：英语项目可输入左右表格
    content: [
      {
        key: 'section7.7.1',
        title: 'Introduction',
        type: 'input'
      },
      {
        key: 'section7.7.2',
        title: 'Main Body',
        type: 'input'
      },
      {
        key: 'section7.7.3',
        title: 'Conclusion',
        type: 'input'
      }
    ]
  },
  {
    key: 'section7.8',
    type: 'paragraph',
    category: 'withBefore',
    leftMark: { // 左侧标记
      type: 'block', // block: 左侧占满 inline：仅第一行有缩进
      width: 97,
      height: 40,
      text: 'Step 4',
      textStyle: {
        fontFamily: 'Calibri', // 字体，本地配置的字体
        fontSize: 24, // 文字大小  默认：20
        lineHeight: 40, // 行高  默认：36
        // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
        fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
        // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
        // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
        textAlign: 'center', // 文字对齐方式 left：左 right：右 center：居中  默认：left
        color: '#fff', // 文本颜色  默认：#00a8ac
        // backgroundColor: '#5CA683', // 背景颜色  默认：无
        backgroundImage: require("@/assets/images/books/book2/title-mark-icon-1.png"),
        paddingLeft: 0,
        paddingRight: 15,
        marginLeft: 0,
        marginRight: 14,
        marginTop: 0,
        marginBottom: 0,
        top: 0,
        left: 0,
      }
    },
    content: { //右侧文本内容，目前只有一段文字
      key: 'section7.8.1', // *必填* 唯一标识
      type: 'text', // *必填* 类型：正文
      isInTable: true,
      content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
        {
          key: 'section7.8.1.1', // *必填* 唯一标识
          category: 'text', // *必填* 内容类型 text：文本
          text: 'Write, revise, and polish your article.', // *必填* 文本内容
          textStyle: {
            fontFamily: 'Arial', // 字体，本地配置的字体
            fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：加粗
          },
        }
      ],
      textStyle: {
        // fontFamily: 'xxx', // 字体，本地配置的字体
        // fontSize: 20, // 文字大小  默认：20
        // lineHeight: 40, // 行高  默认：36
        // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
        // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
        // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
        // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
        // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
        color: '#333', // 文本颜色  默认：#00a8ac
        // backgroundColor: '#FFF', // 背景颜色  默认：无
      },
    },
    // 段落内外间距
    paragraphStyle: {
        marginTop: 34,
        marginBottom: 0,
        padding: 0,
        paddingLeft: 20,
        paddingRight: 20,
    }
  },
  {
    key: 'section7.9',
    type: 'table',
    styleType: 3, // 表格样式 3：英语项目可输入左右表格
    content: [
      {
        key: 'section7.9.1',
        title: 'Article',
        type: 'input',
        height: 350
      }
    ]
  },
  {
    key: 'section7.10',
    type: 'paragraph',
    category: 'withBefore',
    leftMark: { // 左侧标记
      type: 'block', // block: 左侧占满 inline：仅第一行有缩进
      width: 97,
      height: 40,
      text: 'Step 5',
      textStyle: {
        fontFamily: 'Calibri', // 字体，本地配置的字体
        fontSize: 24, // 文字大小  默认：20
        lineHeight: 40, // 行高  默认：36
        // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
        fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
        // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
        // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
        textAlign: 'center', // 文字对齐方式 left：左 right：右 center：居中  默认：left
        color: '#fff', // 文本颜色  默认：#00a8ac
        // backgroundColor: '#5CA683', // 背景颜色  默认：无
        backgroundImage: require("@/assets/images/books/book2/title-mark-icon-1.png"),
        paddingLeft: 0,
        paddingRight: 15,
        marginLeft: 0,
        marginRight: 14,
        marginTop: 0,
        marginBottom: 0,
        top: 0,
        left: 0,
      }
    },
    content: { //右侧文本内容，目前只有一段文字
      key: 'section7.10.1', // *必填* 唯一标识
      type: 'text', // *必填* 类型：正文
      isInTable: true,
      content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
        {
          key: 'section7.10.1.1', // *必填* 唯一标识
          category: 'text', // *必填* 内容类型 text：文本
          text: 'Use a cover image, an catchy title, and a concise article summary to grab followers’ attention. This will persuade your followers to actually click and open your article.', // *必填* 文本内容
          textStyle: {
            fontFamily: 'Arial', // 字体，本地配置的字体
            fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：加粗
          },
        }
      ],
      textStyle: {
        // fontFamily: 'xxx', // 字体，本地配置的字体
        // fontSize: 20, // 文字大小  默认：20
        // lineHeight: 40, // 行高  默认：36
        // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
        // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
        // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
        // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
        // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
        color: '#333', // 文本颜色  默认：#00a8ac
        // backgroundColor: '#FFF', // 背景颜色  默认：无
      },
    },
    // 段落内外间距
    paragraphStyle: {
        marginTop: 34,
        marginBottom: 0,
        padding: 0,
        paddingLeft: 20,
        paddingRight: 20,
    }
  },
  {
    key: 'section7.11',
    type: 'table',
    styleType: 3, // 表格样式 3：英语项目可输入左右表格
    content: [
      {
        key: 'section7.11.1',
        title: 'Cover lmage',
        type: 'upload',
        height: 110
      },
      {
        key: 'section7.11.2',
        title: 'Title',
        type: 'input'
      },
      {
        key: 'section7.11.3',
        title: 'Article Summary',
        type: 'input',
        height: 150
      }
    ]
  },
  {
    key: 'section7.12',
    type: 'paragraph',
    category: 'withBefore',
    leftMark: { // 左侧标记
      type: 'block', // block: 左侧占满 inline：仅第一行有缩进
      width: 97,
      height: 40,
      text: 'Step 6',
      textStyle: {
        fontFamily: 'Calibri', // 字体，本地配置的字体
        fontSize: 24, // 文字大小  默认：20
        lineHeight: 40, // 行高  默认：36
        // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
        fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
        // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
        // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
        textAlign: 'center', // 文字对齐方式 left：左 right：右 center：居中  默认：left
        color: '#fff', // 文本颜色  默认：#00a8ac
        // backgroundColor: '#5CA683', // 背景颜色  默认：无
        backgroundImage: require("@/assets/images/books/book2/title-mark-icon-1.png"),
        paddingLeft: 0,
        paddingRight: 15,
        marginLeft: 0,
        marginRight: 14,
        marginTop: 0,
        marginBottom: 0,
        top: 0,
        left: 0,
      }
    },
    content: { //右侧文本内容，目前只有一段文字
      key: 'section7.12.1', // *必填* 唯一标识
      type: 'text', // *必填* 类型：正文
      isInTable: true,
      content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
        {
          key: 'section7.12.1.1', // *必填* 唯一标识
          category: 'text', // *必填* 内容类型 text：文本
          text: 'Gather visual materials that can be used in your article. Then introduce the main content of each material and explain why you choose to use them. These visual materials could be images, audio, short videos, or even mini-programs related to the festival.Use a cover image, an catchy title, and a concise article summary to grab followers’ attention. This will persuade your followers to actually click and open your article.', // *必填* 文本内容
          textStyle: {
            fontFamily: 'Arial', // 字体，本地配置的字体
            fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：加粗
          },
        }
      ],
      textStyle: {
        // fontFamily: 'xxx', // 字体，本地配置的字体
        // fontSize: 20, // 文字大小  默认：20
        // lineHeight: 40, // 行高  默认：36
        // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
        // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
        // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
        // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
        // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
        color: '#333', // 文本颜色  默认：#00a8ac
        // backgroundColor: '#FFF', // 背景颜色  默认：无
      },
    },
    // 段落内外间距
    paragraphStyle: {
        marginTop: 34,
        marginBottom: 0,
        padding: 0,
        paddingLeft: 20,
        paddingRight: 20,
    }
  },
  {
    key: 'section7.13',
    type: 'table',
    styleType: 3, // 表格样式 3：英语项目可输入左右表格
    content: [
      {
        key: 'section7.13.1',
        title: 'Images',
        type: 'upload',
        height: 110
      },
      {
        key: 'section7.13.2',
        title: 'Audios',
        type: 'upload',
        height: 110
      },
      {
        key: 'section7.13.3',
        title: 'Short Videos',
        type: 'upload',
        height: 110
      },
      {
        key: 'section7.13.4',
        title: 'Mini-programs',
        type: 'input'
      }
    ]
  },
  {
    key: 'section7.14',
    type: 'paragraph',
    category: 'withBefore',
    leftMark: { // 左侧标记
      type: 'block', // block: 左侧占满 inline：仅第一行有缩进
      width: 97,
      height: 40,
      text: 'Step 7',
      textStyle: {
        fontFamily: 'Calibri', // 字体，本地配置的字体
        fontSize: 24, // 文字大小  默认：20
        lineHeight: 40, // 行高  默认：36
        // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
        fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
        // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
        // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
        textAlign: 'center', // 文字对齐方式 left：左 right：右 center：居中  默认：left
        color: '#fff', // 文本颜色  默认：#00a8ac
        // backgroundColor: '#5CA683', // 背景颜色  默认：无
        backgroundImage: require("@/assets/images/books/book2/title-mark-icon-1.png"),
        paddingLeft: 0,
        paddingRight: 15,
        marginLeft: 0,
        marginRight: 14,
        marginTop: 0,
        marginBottom: 0,
        top: 0,
        left: 0,
      }
    },
    content: { //右侧文本内容，目前只有一段文字
      key: 'section7.14.1', // *必填* 唯一标识
      type: 'text', // *必填* 类型：正文
      isInTable: true,
      content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
        {
          key: 'section7.14.1.1', // *必填* 唯一标识
          category: 'text', // *必填* 内容类型 text：文本
          text: 'Layout your article. You should consider font styles, colors, and formatting options that best suit the content. This will make your article visually appealing and enhance the readers’ experience.', // *必填* 文本内容
          textStyle: {
            fontFamily: 'Arial', // 字体，本地配置的字体
            fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：加粗
          },
        }
      ],
      textStyle: {
        // fontFamily: 'xxx', // 字体，本地配置的字体
        // fontSize: 20, // 文字大小  默认：20
        // lineHeight: 40, // 行高  默认：36
        // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
        // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
        // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
        // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
        // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
        color: '#333', // 文本颜色  默认：#00a8ac
        // backgroundColor: '#FFF', // 背景颜色  默认：无
      },
    },
    // 段落内外间距
    paragraphStyle: {
        marginTop: 34,
        marginBottom: 0,
        padding: 0,
        paddingLeft: 20,
        paddingRight: 20,
    }
  },
  {
    key: 'section7.15',
    type: 'paragraph',
    category: 'withBefore',
    leftMark: { // 左侧标记
      type: 'block', // block: 左侧占满 inline：仅第一行有缩进
      width: 97,
      height: 40,
      text: 'Step 8',
      textStyle: {
        fontFamily: 'Calibri', // 字体，本地配置的字体
        fontSize: 24, // 文字大小  默认：20
        lineHeight: 40, // 行高  默认：36
        // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
        fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
        // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
        // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
        textAlign: 'center', // 文字对齐方式 left：左 right：右 center：居中  默认：left
        color: '#fff', // 文本颜色  默认：#00a8ac
        // backgroundColor: '#5CA683', // 背景颜色  默认：无
        backgroundImage: require("@/assets/images/books/book2/title-mark-icon-1.png"),
        paddingLeft: 0,
        paddingRight: 15,
        marginLeft: 0,
        marginRight: 14,
        marginTop: 0,
        marginBottom: 0,
        top: 0,
        left: 0,
      }
    },
    content: { //右侧文本内容，目前只有一段文字
      key: 'section7.15.1', // *必填* 唯一标识
      type: 'text', // *必填* 类型：正文
      isInTable: true,
      content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
        {
          key: 'section7.15.1.1', // *必填* 唯一标识
          category: 'text', // *必填* 内容类型 text：文本
          text: 'Edit your article in the Weixin subscription account of your class and upload it.', // *必填* 文本内容
          textStyle: {
            fontFamily: 'Arial', // 字体，本地配置的字体
            fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：加粗
          },
        }
      ],
      textStyle: {
        // fontFamily: 'xxx', // 字体，本地配置的字体
        // fontSize: 20, // 文字大小  默认：20
        // lineHeight: 40, // 行高  默认：36
        // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
        // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
        // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
        // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
        // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
        color: '#333', // 文本颜色  默认：#00a8ac
        // backgroundColor: '#FFF', // 背景颜色  默认：无
      },
    },
    // 段落内外间距
    paragraphStyle: {
        marginTop: 34,
        marginBottom: 0,
        padding: 0,
        paddingLeft: 20,
        paddingRight: 20,
    }
  },
]
export default content
